export const SortOptionsArray = [
  { label: 'Best Match', value: { fieldName: 'auctionTime', sortOrder: 'Ascending' }, id: 0 },
  {
    label: 'Price Low to High',
    value: { fieldName: 'startingPrice', sortOrder: 'Ascending' },
    id: 1,
  },
  {
    label: 'Price High to Low',
    value: { fieldName: 'startingPrice', sortOrder: 'Descending' },
    id: 2,
  },
  { label: 'Year New to Old', value: { fieldName: 'year', sortOrder: 'Descending' }, id: 3 },
  { label: 'Year Old to New', value: { fieldName: 'year', sortOrder: 'Ascending' }, id: 4 },
  { label: 'Odometer Low to High', value: { fieldName: 'mileage', sortOrder: 'Ascending' }, id: 5 },
  {
    label: 'Odometer High to Low',
    value: { fieldName: 'mileage', sortOrder: 'Descending' },
    id: 6,
  },
]
